import { useStaffGetAllAgents } from '@urbanx/agx.agencies.client';

export function useLeadAgentFilter({
  effectiveAgencyIds,
  selectedLeadAgentIds,
}: {
  effectiveAgencyIds?: string[];
  selectedLeadAgentIds?: string[];
}) {
  const { data: agents = [], isPending } = useStaffGetAllAgents();
  const leadAgentFilterOptions = agents
    .filter((agent) => agent.agencyId && effectiveAgencyIds?.includes(agent.agencyId))
    .map((agent) => ({
      label: agent.name?.fullName ?? '',
      value: agent.id!,
      selected: selectedLeadAgentIds?.includes(agent.id!) ?? false,
    }));
  const agentLookup = Object.fromEntries(agents.map((agent) => [agent.id!, agent]));

  return { leadAgentFilterOptions, agentLookup, isPending };
}
